export const STUDENT_GROUPS = {
  CUSTOMER: {
    ID: '3770fmnkwhzsi',
    NAME: 'Customer',
  },
  KLAVIYO: {
    ID: '2cjw2wwhywn4j',
    NAME: 'Klaviyo',
  },
  PARTNER: {
    ID: '2kl1pxmumqttd',
    NAME: 'Partner',
  },
  TEST_PARTNER: {
    ID: 'y32rqmes9hdr',
    NAME: 'Partner Academy Redesign Testing',
  },
};
